type WrappedRow = readonly (readonly string[])[];
type ReportPage = string[][][];

export function paginateReportRows(
  rows: readonly WrappedRow[],
  options: { contentHeight: number; lineHeight: number; padding: number; repeatColumns?: readonly number[] },
): ReportPage[] {
  const { contentHeight, lineHeight, padding, repeatColumns = [] } = options;
  if (lineHeight <= 0 || contentHeight < lineHeight + padding * 2)
    throw new RangeError("Report page must fit at least one line");
  let current: ReportPage = [];
  const pages: ReportPage[] = [current];
  let usedHeight = 0;
  function newPage() {
    current = [];
    pages.push(current);
    usedHeight = 0;
  }
  for (const row of rows) {
    const rowHeight = Math.max(...row.map((cell) => cell.length)) * lineHeight + padding * 2;
    // Keep normal rows together; only a row taller than a full page may continue.
    if (usedHeight && usedHeight + rowHeight > contentHeight) newPage();
    const remaining = row.map((cell) => [...cell]);
    while (remaining.some((cell) => cell.length)) {
      if (usedHeight + lineHeight + padding * 2 > contentHeight) newPage();
      const available = Math.floor((contentHeight - usedHeight - padding * 2) / lineHeight);
      const chunk = remaining.map((cell, index) =>
        cell.length
          ? cell.splice(0, available)
          : repeatColumns.includes(index)
            ? row[index]?.slice(0, available) || []
            : [],
      );
      current.push(chunk);
      usedHeight += Math.max(...chunk.map((cell) => cell.length)) * lineHeight + padding * 2;
    }
  }
  return pages;
}
